import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AccountingQreDetailsFormAnalyticIds = {
  amountAnalyticId: string;
  countryAnalyticId: string;
  stateAnalyticId: string;
};

export const useAccountingQreDetailsFormAnalyticIds = (): AccountingQreDetailsFormAnalyticIds => ({
  amountAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_AMOUNT),
  countryAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_COUNTRY),
  stateAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_STATE),
});
